import { z } from 'zod/v4';
// Input schema - no parameters needed
export const ListKnowledgeBaseInputSchema = z.object({});
// Output schema
const fileSchema = z.object({
    id: z.string(),
    name: z.string(),
});
const groupSchema = z.object({
    id: z.string(),
    name: z.string(),
    uname: z.string(),
    description: z.string(),
    regions: z.array(z.string()),
    files: z.array(fileSchema),
});
export const ListKnowledgeBaseOutputSchema = z.object({
    groups: z.array(groupSchema),
    workspaceFiles: z.array(fileSchema),
});
//# sourceMappingURL=list-knowledge-base.js.map